import React from 'react'

// components
import MenuContent from './MenuContent'
import SelectSimple from 'components/ui/SelectSimple'

// icon
import { FormattedMessage } from 'react-intl'

const SelectRelations = ({ count }) => {
  return (
    <SelectSimple
      menuContent={<MenuContent count={count} />}
      buttonContent={<FormattedMessage id='select-relations' />}
    />
  )
}

export default SelectRelations
